"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _parseButtons = _interopRequireDefault(require("./parseButtons"));

var _parseLabels = _interopRequireDefault(require("./parseLabels"));

var _parseViews = _interopRequireDefault(require("./parseViews"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var parseTheme = function parseTheme(props) {
  var fonts = props.fonts,
      colors = props.colors,
      elements = props.elements;
  var views = (0, _parseViews["default"])({
    views: elements.views,
    theme: {
      fonts: fonts,
      colors: colors,
      elements: elements
    }
  });
  var labels = (0, _parseLabels["default"])({
    labels: elements.labels,
    theme: {
      fonts: fonts,
      colors: colors,
      elements: elements
    }
  });
  var buttons = (0, _parseButtons["default"])({
    buttons: elements.buttons,
    views: views,
    labels: labels,
    theme: {
      fonts: fonts,
      colors: colors,
      elements: elements
    }
  });
  return {
    views: views,
    labels: labels,
    buttons: buttons
  };
};

var _default = parseTheme;
exports["default"] = _default;